export default __webpack_public_path__ + "static/media/element_spec_91.b99e39ff.webp";